import { render } from "./premium.vue?vue&type=template&id=2d9ad423&scoped=true"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"

import "./premium.vue?vue&type=style&index=0&id=2d9ad423&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9ad423"]])

export default __exports__